// TODO: replace string literals with variables - (phyoh)
import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../client/analytics';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  PROPERTIES_PAGE_OUR_APP: '8183',
  PROPERTIES_PAGE_HIRE_PHOTOGRAPHER: '8184',
  LEARN_MORE: '8185',
  POSTING_PATH_OUR_APP: '8186',
  POSTING_PATH_HIRE_PHOTOGRAPHER: '8187',
} as const;

// https://dataportal.zillowgroup.net/event-registry/8183
const PropertiesPageOurApp = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.PROPERTIES_PAGE_OUR_APP,
      event_type_version_id: '2',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'properties',
      trigger_object_nm: 'our_app',
      trigger_source_nm: '3d_tour_modal',
    },
    semantic: {
      semantic_event_nm: 'properties_3d_tour_modal_our_app',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8184
const PropertiesPageHirePhotographer = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_type_id: EVENT_IDS.PROPERTIES_PAGE_HIRE_PHOTOGRAPHER,
      event_type_version_id: '2',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'properties',
      trigger_object_nm: 'hire_a_photographer',
      trigger_source_nm: '3d_tour_modal',
    },
    semantic: {
      semantic_event_nm: 'properties_3d_tour_modal_hire_a_photographer',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8185
const LearnMore = ({ currentProperty, user }: { currentProperty: ZrmClickstreamListing; user: ZrmClickstreamUser }) =>
  trackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.LEARN_MORE,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'posting_path',
      trigger_object_nm: 'learn_more',
      trigger_source_nm: '3d_tour_rec',
    },
    semantic: {
      semantic_event_nm: 'posting_path_3d_tour_rec',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8186
const PostingPathOurApp = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.POSTING_PATH_OUR_APP,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'posting_path',
      trigger_object_nm: 'our_app',
      trigger_source_nm: '3d_tour_modal',
    },
    semantic: {
      semantic_event_nm: 'posting_path_3d_tour_modal_our_app',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8187
const PostingPathHirePhotographer = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.POSTING_PATH_HIRE_PHOTOGRAPHER,
      event_type_version_id: '1',
      event_template_id: '168',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'posting_path',
      trigger_object_nm: 'hire_a_photographer',
      trigger_source_nm: '3d_tour_modal',
    },
    semantic: {
      semantic_event_nm: 'posting_path_3d_tour_modal_hire_a_photographerr',
      topic_tag_txt: ['zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// Clickstream visualizer data-eventid attributes
PropertiesPageOurApp.data_event_id = EVENT_IDS.PROPERTIES_PAGE_OUR_APP;
PropertiesPageHirePhotographer.data_event_id = EVENT_IDS.PROPERTIES_PAGE_HIRE_PHOTOGRAPHER;
LearnMore.data_event_id = EVENT_IDS.LEARN_MORE;
PostingPathOurApp.data_event_id = EVENT_IDS.POSTING_PATH_OUR_APP;
PostingPathHirePhotographer.data_event_id = EVENT_IDS.POSTING_PATH_HIRE_PHOTOGRAPHER;

const Add3DToursCSEvents = {
  PropertiesPageOurApp,
  PropertiesPageHirePhotographer,
  LearnMore,
  PostingPathOurApp,
  PostingPathHirePhotographer,
};

export default Add3DToursCSEvents;
